import { motion, AnimatePresence } from 'framer-motion';
import { AlertTriangle, Zap, X } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import { useQuotaUsage } from '../hooks/useQuotaUsage';

export const QuotaBanner = () => {
  const { isDark } = useTheme();
  const { mostSevere, isDismissed, dismissUntilTomorrow, openUpgrade } = useQuotaUsage();

  if (!mostSevere || isDismissed) return null;

  const isCritical = mostSevere.percent >= 95;
  const { meta, used, limit, remaining, percent } = mostSevere;

  const message = isCritical
    ? `Plus que ${remaining} ${meta.noun}${remaining > 1 ? 's' : ''} ${meta.period} — tu vas atteindre la limite.`
    : `Tu as utilisé ${used}/${limit} ${meta.label} ${meta.period} (${Math.round(percent)}%).`;

  const cta = isCritical ? 'Passer Plus pour débloquer' : 'Voir les plans';

  const palette = isCritical
    ? { bg: 'bg-[#FF6B6B]/15', border: 'border-[#FF6B6B]/30', text: 'text-[#FF6B6B]', icon: AlertTriangle }
    : { bg: 'bg-[#f59e0b]/15', border: 'border-[#f59e0b]/30', text: 'text-[#f59e0b]', icon: Zap };

  const Icon = palette.icon;

  return (
    <AnimatePresence>
      <motion.div
        key={mostSevere.key + (isCritical ? '-c' : '-w')}
        initial={{ opacity: 0, y: -12 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -12 }}
        transition={{ duration: 0.25 }}
        className={`sticky top-0 z-30 mx-4 mt-4 rounded-xl border backdrop-blur-sm ${palette.bg} ${palette.border}`}
        data-testid="quota-banner"
      >
        <div className="flex items-center gap-3 px-4 py-3">
          <Icon size={18} strokeWidth={2} className={palette.text} />
          <div className="flex-1 min-w-0">
            <p className={`text-sm font-medium ${isDark ? 'text-white' : 'text-gray-900'}`}>{message}</p>
          </div>
          <button
            onClick={openUpgrade}
            className={`px-3 py-1.5 rounded-lg text-xs font-semibold transition-colors ${palette.text} hover:bg-white/10 border ${palette.border} whitespace-nowrap`}
            data-testid="quota-banner-cta"
          >
            {cta}
          </button>
          <button
            onClick={dismissUntilTomorrow}
            className={`p-1 rounded transition-colors ${isDark ? 'text-white/40 hover:text-white' : 'text-gray-400 hover:text-gray-700'}`}
            aria-label="Masquer pour 24h"
            data-testid="quota-banner-dismiss"
          >
            <X size={16} />
          </button>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default QuotaBanner;
